<template>
  <div>
    <div class="zn-template-head">
      <span class="zn-template-title">3 3 1 详解</span>
    </div>
    <div class="zn-template-content" ref="tplContent">
      <div style="border:1px solid #eee;border-radius:4px;padding:10px;line-height:2;margin-top:10px">
        <div style="color:#999">第一个 “ 三 ” 找出这个项目的至少三个亮点（selling points）。三个亮点包括：公司亮点，职位亮点</div>
        <div style="padding-left:15px">
        【公司亮点包括】：大平台、固定薪酬高、口碑好、快速发展、激励机制非常有吸引力、大佬领衔、性价比高、工作强度不大，文化氛围好<br/>
        【职位亮点包括】：高职级（比如部门负责人，资深岗）、高权限、可以给到好的激励、回报老板很强、有管理职权、重点业务，将来发展空间大，离家近，下班早，晋级快，等等。
        </div>
        <div style="color:#999">第二个 “ 三 ” 找出这个职位对于人选要求的三个关键核心要求</div>
        <div style="padding-left:15px">
        【最核心的点】：这个岗位需要解决客户什么问题、痛点，或者达到什么目标？要实现需要的关键专业技能是什么？软性要求是什么？这家公司对于人最大的偏好，或者不达标一定进不来的点是什么？
        </div>
        <div style="color:#999">最后那个 “ 一 ” 列出这个职位的风险点</div>
        <div style="padding-left:15px">
        【什么是风险点】：人选刚开始进展顺利，但是最后可能突然职位黄掉了。最后关键时刻，可能客户因为这个风险点不录用人选，或者人选可能因此不接Offer的都叫风险点。
        </div>
      </div>
      <div style="margin:15px 5px">331文字版培训：<span class="a-link" @click="preview('a03de0c4062deadc7fa2055c96a20ecb')">三三一法则</span></div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    async preview(md5) {
      const ref = app.root.$refs.cvPreview
      if (!ref) return
      ref.getFile({ md5 })
      ref.show()
    },
  }
}
</script>
